/* eslint-disable react/prop-types */
import classes from "./card-view-module.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";

function CardViewModule({ item }) {
  return (
    <Flex
      align="center"
      direction="column"
      justify="center"
      className={classes.container}
    >
      <img src={item.image} alt="Logo" className={classes.image} />
      <Flex align="flex-start" direction="column" justify="center">
        <Label
          weight="bold"
          tag="h6"
          color="secondary"
          align="start"
          className={classes.title}
        >
          {item.title}
        </Label>
        <Label align="start" size="md" color="secondary">
          {item.content}
        </Label>
      </Flex>
    </Flex>
  );
}

export default CardViewModule;
